import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import { ErrorBoundary } from 'shared/components/error-boundary';
import { ControlWithoutValidation } from 'shared/components/fields/control/without-validation';
import { TextInputWrapper } from 'shared/components/fields/text';
import { Alert, IconButton, InputAdornment, LinearProgress } from '@mui/material';
import { Save } from '@mui/icons-material';
import { useMutationCallback } from 'shared/api/hooks';
export function SimNotes(props) {
    const { sim_type, msisdn, iccid, sim_notes } = props;
    const [notes, setNotes] = useState(sim_notes);
    useEffect(() => {
        setNotes(sim_notes);
    }, [sim_notes]);
    const [save, isLoading, , error] = useMutationCallback('sim/set_notes');
    const onSave = useCallback(() => {
        save({ sim_notes: notes, sim_type, msisdn, iccid });
    }, [sim_type, msisdn, iccid, notes]);
    const field = useCallback((input_props) => (_jsx(TextInputWrapper, { ...input_props, endAdornment: _jsx(InputAdornment, { position: "end", children: _jsx(IconButton, { onClick: onSave, size: "large", disabled: notes == sim_notes, children: _jsx(Save, {}) }) }) })), [onSave, notes, sim_notes]);
    return (_jsx(ErrorBoundary, { children: _jsxs("form", { autoComplete: "off", children: [_jsx(ControlWithoutValidation, { label: "\u0417\u0430\u043C\u0435\u0442\u043A\u0430", value: notes, onChange: setNotes, field: field }), isLoading && _jsx(LinearProgress, {}), error && _jsx(Alert, { severity: "error", children: error })] }) }));
}
